import { Box, Typography, Link } from "@mui/material";
import React from "react";

interface GeneralInformation {
  label: string;
  value: string;
  link?: string;
}

interface BasicHomeSiteDetailsProps {
  generalInformation: GeneralInformation[];
}

const BasicHomeSiteDetails: React.FC<BasicHomeSiteDetailsProps> = ({ generalInformation }) => {
  return (
    <Box sx={{ width: "100%", maxWidth: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", overflow: "hidden", whiteSpace: "nowrap", backgroundColor: "#FAFBFC" }}>
      {generalInformation.map((item) => (
        <Box key={item.label} sx={{ flex: "1 1 auto", maxWidth: "200px", marginRight: "16px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          <Typography variant="caption" sx={{ fontSize: "11px", fontWeight: 500, color: "#5B7282", display: "block", marginBottom: "4px", }}>
            {item.label}
          </Typography>
          <Typography variant="body2" sx={{ fontSize: "14px", fontWeight: 700, color: "#1C2B36", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
            {item.link ? (
              <Link
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: "primary.main" }}
                aria-label={`Open ${item.label} in a new tab`}
              > 
                {item.value}
              </Link>
            ) : (
              item.value || "---"
            )}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default BasicHomeSiteDetails;
